import { render } from "./External.vue?vue&type=template&id=652e2cd6&scoped=true"
import script from "./External.vue?vue&type=script&lang=js"
export * from "./External.vue?vue&type=script&lang=js"

import "./External.vue?vue&type=style&index=0&id=652e2cd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652e2cd6"]])

export default __exports__